import * as types from "./types";

function saveData(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function obtenerListaColegios(payload) {
  return { type: types.FETCH_LISTA_COLEGIOS, payload };
}

function resetListaColegios() {
  return { type: types.RESET_LISTA_COLEGIOS };
}

function itemsTotales(payload) {
  return { type: types.ITEMS_TOTALES, payload };
}

function paginasTotales(payload) {
  return { type: types.PAGINAS_TOTALES, payload };
}

function itemsPorPagina(payload) {
  return { type: types.ITEMS_POR_PAGINA, payload };
}

function paginaActual(payload) {
  return { type: types.PAGINA_ACTUAL, payload };
}

function setTipoListado(payload) {
  return { type: types.TIPO, payload };
}

function itemsInicialesPorPagina(payload) {
  return { type: types.INICIOS_DE_PAGINA, payload };
}

function seleccionarColegio(payload) {
  return { type: types.SELECCIONAR_COLEGIO, payload };
}

function quitarColegioSeleccionado() {
  return { type: types.QUITAR_COLEGIO_SELECCIONADO };
}

function addedAccionesDeVenta(payload) {
  return { type: types.ADDED_ACCIONES_VENTA, payload };
}

function removedAccionesDeVenta(payload) {
  return { type: types.REMOVED_ACCIONES_VENTA, payload };
}

function changedAccionesDeVenta(payload) {
  return { type: types.CHANGED_ACCIONES_VENTA, payload };
}

function limpiarAccionesDeVenta() {
  return { type: types.LIMPIAR_ACCIONES_VENTA };
}

function setProvinciaActiva(payload) {
  return { type: types.SET_PROVINCIA_ACTIVA, payload };
}
function resetProvinciaActiva() {
  return { type: types.RESET_PROVINCIA_ACTIVA };
}

function obtenerNombreColegios(payload) {
  return { type: types.OBTENER_NOMBRE_COLEGIOS, payload };
}

function limpiarNombreColegios() {
  return { type: types.LIMPIAR_NOMBRE_COLEGIOS };
}

function obtenerLocalidades(payload) {
  return { type: types.OBTENER_LOCALIDADES, payload };
}

function limpiarLocalidades() {
  return { type: types.LIMPIAR_LOCALIDADES };
}

function setColegioBuscado(payload) {
  return { type: types.SET_COLEGIO_BUSCADO, payload };
}

function resetColegioBuscado() {
  return { type: types.RESET_COLEGIO_BUSCADO };
}

function setLocalidadBuscada(payload) {
  return { type: types.SET_LOCALIDAD, payload };
}

function resetLocalidadBuscada() {
  return { type: types.RESET_LOCALIDAD };
}

/*---*/
export {
  saveData,
  resetDataSaved,
  obtenerListaColegios,
  resetListaColegios,
  itemsTotales,
  paginasTotales,
  itemsPorPagina,
  paginaActual,
  setTipoListado,
  itemsInicialesPorPagina,
  seleccionarColegio,
  quitarColegioSeleccionado,
  addedAccionesDeVenta,
  removedAccionesDeVenta,
  changedAccionesDeVenta,
  limpiarAccionesDeVenta,
  setProvinciaActiva,
  resetProvinciaActiva,
  obtenerNombreColegios,
  limpiarNombreColegios,
  obtenerLocalidades,
  limpiarLocalidades,
  setColegioBuscado,
  resetColegioBuscado,
  setLocalidadBuscada,
  resetLocalidadBuscada
};



// WEBPACK FOOTER //
// ./src/ducks/ventas/actions.js